import { DialogWaermeVerbrauch } from '../../../dialogs/DialogWaermeVerbrauch';
import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';

export interface WaermeButtonWrapperProps {
    data: any;
    values: any;
    jahr: number;
    standortSelected: any;
    disabled?: boolean;
    callback: (data: any) => void;
}

export interface WaermeButtonWrapperState {
    dataForOptionalDialog: any;
}

export class WaermeButtonWrapper extends React.Component<WaermeButtonWrapperProps, WaermeButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataForOptionalDialog: undefined,
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private buttonOnAction: any;

    componentWillUnmount(): void {
        console.log('Dialog unmount');
        if (this.buttonOnAction) {
            this.triggerService.unregister('onAction', 'WaermeButtonWrapper', this.buttonOnAction);
        }
    }

    render(): JSX.Element {
        const { dataForOptionalDialog } = this.state;
        const { standortSelected, jahr, values } = this.props;
        const disabled = !values.energietraeger_tid || !values.einheit_tid;

        if (!values) {
            return <span></span>;
        }

        const onClose = () => {
            this.setState({ dataForOptionalDialog: undefined });
        };

        let title: string;
        if (this.state.dataForOptionalDialog) {
            const energietraegerTid = (values || {}).energietraeger_tid_orig;
            const energietraeger = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_WAERME}_bundle`] || {}).energietraeger_tid || [])
                .find((item: any) => item.tid === energietraegerTid) || {}).name || '';
            title = `${jahr}\u00A0\u00A0\u00A0\u00A0\u00A0${standortSelected.name}\u00A0\u00A0\u00A0\u00A0\u00A0${energietraeger}`;
        }

        return (
            <div style={{ marginTop: -10, marginBottom: 20 }}>
                <WActionButton
                    styleProps={{ ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {}) }}
                    label='Monatsverbräuche'
                    insideText='Monatsverbräuche'
                    tooltip='Monatsverbräuche bearbeiten'
                    key='monatsverbraeuche'
                    action='calculator'
                    onAction={() => {
                        if (disabled) {
                            // alert('Bitte wählen Sie zunächst Monatsrechnungen, Energieträger, und Einheit aus.');
                        } else {
                            const dataForDialog = {
                                standortSelected,
                                entity: { entity: IDs.ENT_ENERGIEDATEN_WAERME },
                                jahr,
                                values
                            };
                            if (JSON.stringify(dataForOptionalDialog) !== JSON.stringify(dataForDialog)) {
                                this.setState({ dataForOptionalDialog: dataForDialog });
                            }
                        }
                    }}
                    ref={(button: any) => {
                        if (button && !this.buttonOnAction) {
                            // Siehe auch onFormChangeWaermeAutoOpenDialog
                            this.buttonOnAction = button.props.onAction;
                            this.triggerService.register('onAction', 'WaermeButtonWrapper', this.buttonOnAction);
                        }
                    }}
                />
                {this.state.dataForOptionalDialog &&
                    <DialogWrapper2
                        title={title}
                        width={-1}
                        onAfterClose={onClose}
                    >
                        <DialogWaermeVerbrauch
                            data={this.props.data}
                            standortSelected={dataForOptionalDialog.standortSelected}
                            jahr={dataForOptionalDialog.jahr}
                            values={dataForOptionalDialog.values}
                            onChange={(entityName: string, formValues: any) => {
                                onClose();
                                const vals = dataForOptionalDialog.values;
                                vals.abrechnungszeitraum_von = formValues.abrechnungszeitraum_von;
                                vals.abrechnungszeitraum_bis = formValues.abrechnungszeitraum_bis;
                                vals.verbrauch = formValues.verbrauch;
                                vals.kosten = formValues.kosten;
                                vals.co2_emissionen = formValues.co2_emissionen;
                                this.props.callback(vals);
                                this.triggerService.fire('reload', entityName);
                            }}
                            onClose={onClose}
                        />
                    </DialogWrapper2>
                }
            </div>
        );
    }
}
